/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_3_QInputs */

const en_pc_faq_3_q = /** @type {(inputs: Pc_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are PhotoCraft and ArtCraft related?`)
};

const zh_pc_faq_3_q = /** @type {(inputs: Pc_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft 和 ArtCraft 是什么关系？`)
};

/**
* | output |
* | --- |
* | "How are PhotoCraft and ArtCraft related?" |
*
* @param {Pc_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_3_q = /** @type {((inputs?: Pc_Faq_3_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_3_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_3_q(inputs)
	return zh_pc_faq_3_q(inputs)
});
export { pc_faq_3_q as "pc.faq.3.q" }